import { BowserParseDataInterface, bowserParseData } from './bowser.helper';

export interface UserAgentDataInterface {
    portal: string;
    deviceType: string;
    application: string;
    os: string;
    build: number;
    player?: string;
    osInfo?: string;
    widevine?: boolean;
    noChannels?: boolean;
    noDrm?: boolean;
}

export function getUserAgentData(portal: string): UserAgentDataInterface {
    const bowserData = bowserParseData();

    return {
        portal,
        deviceType: getDeviceType(bowserData),
        application: getApplication(bowserData),
        os: getOS(bowserData),
        build: 1,
    };
}

export function getUserAgent(baseUserAgent: string): string {
    return (typeof window === 'object' && baseUserAgent)
        ? `${baseUserAgent} (${window.navigator.userAgent})`
        : '';
}

function getDeviceType(bowserData: BowserParseDataInterface): string {
    switch (bowserData.getPlatformType()) {
        case 'tablet':
            return 'tablet';

        case 'mobile':
            return 'phone';

        default:
            return 'pc';
    }
}

function getApplication(bowserData: BowserParseDataInterface): string {
    switch (bowserData.getBrowserName()) {
        case 'Chrome':
            return 'chrome';

        case 'Firefox':
            return 'firefox';

        case 'Opera':
            return 'opera';

        case 'Internet Explorer':
            return 'ie';

        case 'Safari':
            return 'safari';

        case 'Microsoft Edge':
            return 'edge';

        default:
            return 'browser';
    }
}

function getOS(bowserData: BowserParseDataInterface): string {
    switch (bowserData.getOSName()) {
        case 'Windows':
            return 'windows';

        case 'Linux':
            return 'linux';

        case 'macOS':
            return 'osx';

        case 'Android':
            return 'android';

        case 'iOS':
            return 'ios';

        default:
            return 'other';
    }
}
